/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {BidiModule} from '../bidi';
import {PortalModule} from '../portal';
import {ScrollingModule} from '../scrolling';
import {NgModule} from '@angular/core';
import {Overlay} from './overlay';
import {CdkConnectedOverlay, CdkOverlayOrigin} from './overlay-directives';

@NgModule({
  imports: [BidiModule, PortalModule, ScrollingModule, CdkConnectedOverlay, CdkOverlayOrigin],
  exports: [CdkConnectedOverlay, CdkOverlayOrigin, ScrollingModule],
  providers: [Overlay],
})
export class OverlayModule {}

// Re-export needed by the Angular compiler.
// See: https://github.com/angular/components/issues/30663.
// Note: These exports need to be stable and shouldn't be renamed unnecessarily because
// consuming libraries might have references to them in their own partial compilation output.
export {
  CdkScrollableModule as ÉµÉµCdkScrollableModule,
  CdkFixedSizeVirtualScroll as ÉµÉµCdkFixedSizeVirtualScroll,
  CdkVirtualForOf as ÉµÉµCdkVirtualForOf,
  CdkVirtualScrollViewport as ÉµÉµCdkVirtualScrollViewport,
  CdkVirtualScrollableWindow as ÉµÉµCdkVirtualScrollableWindow,
  CdkVirtualScrollableElement as ÉµÉµCdkVirtualScrollableElement,
} from '../scrolling';
export {Dir as ÉµÉµDir} from '../bidi';
